import React, { useState } from "react";
import { Radar, Briefcase, Eye, Trophy } from "lucide-react";
import MarketScan from "../components/MarketScan";
import Watchlist from "../components/Watchlist";
import TrackRecord from "../components/TrackRecord";
import PortfolioRecos from "./PortfolioRecos";

const MODES = [
  ["scan", "Market Scan", Radar, MarketScan],
  ["watchlist", "Watchlist", Eye, Watchlist],
  ["track", "Track Record", Trophy, TrackRecord],
  ["portfolio", "My Portfolio", Briefcase, PortfolioRecos],
];

export default function Recommendations() {
  const [mode, setMode] = useState("scan");
  const View = MODES.find((m) => m[0] === mode)[3];
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 sm:flex rounded-xl border border-[#2d3c59] p-1 gap-1 w-full sm:w-fit bg-[#0b1220]" data-testid="reco-mode-switch">
        {MODES.map(([k, l, Icon]) => (
          <button key={k} data-testid={`reco-mode-${k}`} onClick={() => setMode(k)}
            className={`flex items-center justify-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm whitespace-nowrap transition-colors ${mode === k ? "bg-[#00e5ff] text-[#06121a] font-medium" : "text-[#94a3b8] hover:text-[#f8fafc]"}`}>
            <Icon className="w-4 h-4" /> {l}
          </button>
        ))}
      </div>
      <View />
    </div>
  );
}
